// src/pages/register.jsx
import React, { useState } from 'react';
import { motion } from "framer-motion";
import { Link, ScrollRestoration } from 'react-router-dom';

import axiosInstance from '../utils/axiosInstance';

import PageTitle from '../components/common/pageTitle';
import { slideUp } from '../utils/slideUp';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    // Send register request to backend
    try {
      const response = await axiosInstance.post('/api/auth/register', { email, password });

      // On successful registration, the backend should return a message telling user to verify email
      setSuccessMessage('註冊成功！請前往註冊信箱收取驗證信');
      setEmail('');
      setPassword('');
    } catch (err) {
      console.error(err);
      // Check if the error response exists and has a message
      setError(err.response?.data?.error || 'Something went wrong. Please try again later.');
    }
  };

  return (
    <>
      <PageTitle link={"註冊帳號"} pageName={"註冊帳號"} />

      <div className="login-area ptb-100">
        <div className="container">
          <motion.div className="login-info"
            initial="offscreen"
            whileInView="onscreen"
            variants={slideUp(1)}
            viewport={{ once: true, amount: 0 }}
          >
            <h1>立即註冊</h1>
            <form onSubmit={handleSubmit}>
              {error && <div className="alert alert-danger">{error}</div>}
              {successMessage && <div className="alert alert-success">{successMessage}</div>}
              <div className="form-group">
                <input 
                  type="email" 
                  className="form-control" 
                  placeholder="Email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  required
                />
              </div>
              <div className="form-group">
                <input 
                  type="password" 
                  className="form-control" 
                  placeholder="Your password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)}
                  required 
                />
              </div>
              <button className="default-btn border-0" type="submit">
                <i className="ri-arrow-right-line"></i>
                註冊
              </button>
              <p>已經有帳號了嗎？請<Link className="text-decoration-none" to="/login">由此</Link>登入</p>
            </form>
          </motion.div>
        </div>
      </div>
      <ScrollRestoration />
    </>
  );
};

export default Register;


